import { purry } from './purry';
export function sortBy() {
  return purry(_sortBy, arguments);
}

function _sortBy(array, fn) {
  var copied = array.slice();
  return copied.sort(function (a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
}